import {fetchQuestions} from "../api";

export default {
    namespaced: true,
    state: {
        startId: null,
        all: [],
    },
    getters: {
        getStartId(state) {
            return state.startId;
        },
        getQuestionById: (state) => (id) => {
            return state.all[id];
        },
        getAnswer: (state, getters) => ({questionId, answerId}) => {
            const question = getters['getQuestionById'](questionId);
            return question.answers.find(answer => answer.id === answerId);
        },
    },
    actions: {
        fetch: ({commit, state, rootState}, questions) => {
            let newQuestionIds;

            if (Array.isArray(questions) && questions.length === 0) {
                return;
            }

            newQuestionIds = questions.filter(id => {
                return !Object.keys(state.all).includes(id) && id != null;
            });

            if (!newQuestionIds.length) {
                return;
            }

            return fetchQuestions(newQuestionIds, rootState.environment).then(({data}) => {
                commit('addQuestions', data);
            });
        },
        fetchForQuestion: ({getters, dispatch}, questionId) => {
            const question = getters['getQuestionById'](questionId);
            const newQuestionIds = question.answers.map(answer => answer.target_question_id);
            dispatch('fetch', newQuestionIds);
        },
    },
    mutations: {
        addQuestions: (state, questions) => {
            const keyedQuestions = questions.reduce((acc, question) => {
                acc[question.id] = question;
                return acc;
            }, {});

            state.all = {...state.all, ...keyedQuestions};
        },
        setQuestions: (state, data) => {
            state.all = data;
        },
    },
};
